/**
 * The file name from a Content-Disposition header.
 *
 * Prefers the RFC 5987 ``filename*=UTF-8''<percent-encoded>`` form (the
 * exact name, any script), then a quoted ``filename="..."`` (honoring
 * backslash escapes so a name with a quote or semicolon is not truncated),
 * then a bare token. Returns '' when there is none.
 */
export function parseDispositionFilename(header) {
    const text = String(header || '')
    const star = /filename\*\s*=\s*([^']*)'[^']*'([^;]+)/i.exec(text)
    if (star) {
        try {
            return decodeURIComponent(star[2].trim())
        } catch (e) {
            // fall through to the plain filename
        }
    }
    const quoted = /filename\s*=\s*"((?:[^"\\]|\\.)*)"/i.exec(text)
    if (quoted) return quoted[1].replace(/\\(.)/g, '$1')
    const bare = /filename\s*=\s*([^;\s]+)/i.exec(text)
    return bare ? bare[1] : ''
}
